import React from "react";
import { ExternalLink } from "lucide-react";

const STORES = [
  {
    name: "Rachvid Wears",
    tagline: "Full fashion catalog — hoodies, sneakers, hats, bags & more",
    url: "https://www.rachvidwearsusa.com",
    image: "https://images.pexels.com/photos/4000933/pexels-photo-4000933.jpeg",
    accent: "var(--davide-red)",
  },
  {
    name: "AliveShoes · Rachvid",
    tagline: "Custom Rachvid footwear crafted in Italy",
    url: "https://www.aliveshoes.com/rachvid",
    image: "https://images.unsplash.com/photo-1713845784497-fe3d7ed176d8",
    accent: "var(--davide-blue)",
  },
];

export default function ExternalStores() {
  return (
    <section className="py-24 bg-[#0E0E0E]" data-testid="external-stores">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="overline mb-3">Also Shop At</p>
            <h2 className="font-display text-4xl md:text-5xl font-light text-white tracking-tight">
              The DaviDÉ Universe.
            </h2>
            <p className="text-white/60 mt-3 max-w-xl">
              Explore the full extended catalog across our partner boutiques.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {STORES.map((s) => (
            <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer"
              data-testid={`external-store-${s.name.toLowerCase().replace(/[^a-z]/g, '-')}`}
              className="group relative block overflow-hidden border border-white/10 hover:border-[var(--davide-gold)] transition-colors">
              <div className="aspect-[16/9] overflow-hidden">
                <img src={s.image} alt={s.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-90" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <div className="h-1 w-12 mb-4" style={{ background: s.accent }} />
                <h3 className="font-display text-2xl md:text-3xl text-white group-hover:text-[var(--davide-gold)] transition-colors">
                  {s.name}
                </h3>
                <p className="text-white/70 text-sm mt-2 max-w-md">{s.tagline}</p>
                <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[var(--davide-gold)] mt-4">
                  Visit Store <ExternalLink size={12} />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
